import React from 'react';
import Head from 'next/head';
import { string } from 'prop-types';
import { SITE_NAME } from 'constants/site';

/**
 * factory function to return a LinkTag component with desired props. because
 * all meta <link /> tags are not created equal. defaults to:
 *
 *   <link rel="" href="" />
 *
 * @export
 * @param {Object} [defaults={}] defaults for meta tag
 * @param {String} [defaults.keyName='rel'] the HTML attr to use for the 'rel' key
 * @param {String} [defaults.valueName='href'] the HTML attr to use for the 'href' key
 * @returns {Function} factory function
 */
export default function createLinkTag(defaults = {}) {
  const { keyName = 'rel', valueName = 'href' } = defaults;

  /**
   * LinkTag is a component that renders an "abstract" <link /> tag (no
   * defined keyName and valueName)
   */
  function LinkTag(props) {
    const { name, value } = props;
    const linkProps = {
      [keyName]: name,
      [valueName]: value
    };

    /**
     * CLEANUP: revisit overall metadata structure and/or the way more specific
     * link tags are rendered. Maybe appending "RSS Feed" to a title that comes
     * from elsewhere
     */
    if (name === 'alternate') {
      linkProps.type = 'application/rss+xml';
      linkProps.title = SITE_NAME;
    }

    return (
      <Head>
        <link {...linkProps} />
      </Head>
    );
  }

  LinkTag.propTypes = {
    // name and value props are from the 'data' attr in our bundle item schema
    name: string.isRequired,
    value: string.isRequired,
    type: string,
    title: string
  };

  LinkTag.defaultProps = {
    type: '',
    title: ''
  };

  return LinkTag;
}
